import { render, staticRenderFns } from "./permit-edit.vue?vue&type=template&id=61d1055d&scoped=true"
import script from "./permit-edit.vue?vue&type=script&lang=js"
export * from "./permit-edit.vue?vue&type=script&lang=js"
import style0 from "./permit-edit.vue?vue&type=style&index=0&id=61d1055d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d1055d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d1055d')) {
      api.createRecord('61d1055d', component.options)
    } else {
      api.reload('61d1055d', component.options)
    }
    module.hot.accept("./permit-edit.vue?vue&type=template&id=61d1055d&scoped=true", function () {
      api.rerender('61d1055d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/component/permit-edit.vue"
export default component.exports